(() => {
  const bindHeader = () => {
    document.querySelectorAll('[data-hs-header]').forEach(header => {
      if (header.dataset.hsEnhanced) return;
      header.dataset.hsEnhanced = 'true';
      const toggle = header.querySelector('[data-hs-menu-toggle]');
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      const mobile = window.matchMedia('(max-width:989px)');
      const setOpen = (open, restoreFocus = false) => {
        header.toggleAttribute('data-hs-open', open && mobile.matches);
        toggle.setAttribute('aria-expanded', String(open && mobile.matches));
        toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
        nav.inert = mobile.matches && !open;
        if (restoreFocus) toggle.focus();
      };
      toggle.addEventListener('click', () => setOpen(!header.hasAttribute('data-hs-open')));
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape') setOpen(false, true);
      });
      nav.addEventListener('click', event => {
        if (event.target.closest('a')) setOpen(false);
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) setOpen(false);
      });
      header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) setOpen(false);
      });
      mobile.addEventListener('change', () => setOpen(false));
      setOpen(false);
    });
    document.querySelectorAll('[data-hs-search-open]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog) return;
      button.addEventListener('click', () => {
        dialog.showModal();
        button.setAttribute('aria-expanded', 'true');
      });
      dialog.querySelector('[data-hs-search-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      });
    });
  };
  bindHeader();
  document.addEventListener('shopify:section:load', bindHeader);
})();
